
export function removeFromArray(arr, value) {
   return arr.filter(function(ele){
       return ele !== value;
   });
}
